let ArrayPrototype = Array.prototype;

const ELEMENT_NODE = 1;

let DOMTokenList = function(elem, propName) {
  this.elem = elem;
  this.propName = propName;
  this.length = 0;

  if (elem.nodeType === ELEMENT_NODE) {
    let tokens = elem[propName].match(/\S+/g);
    if (tokens) {
      for (let i = 0; i < tokens.length; i++) {
        ArrayPrototype.push.call(this, tokens[i]);
      }
    }
  }
};

DOMTokenList.prototype = {
  add: function(token) {
    let i = ArrayPrototype.indexOf.call(this, token);
    if (i === -1) {
      ArrayPrototype.push.call(this, token);
      this.elem[this.propName] = '' + this;
    }
  },

  contains: function(token) {
    return ArrayPrototype.indexOf.call(this, token) !== -1;
  },

  item: function(index) {
    return this[index] || null;
  },

  remove: function(token) {
    let i = ArrayPrototype.indexOf.call(this, token);
    if (i !== -1) {
      ArrayPrototype.splice.call(this, i, 1);
      this.elem[this.propName] = '' + this;
    }
  },

  toString: function() {
    return ArrayPrototype.join.call(this, ' ');
  },

  toggle: function(token) {
    let contains = this.contains(token);

    if (contains) {
      this.remove(token);
    } else {
      this.add(token);
    }

    return !contains;
  }
};

export default function getDOMTokenList(elem, propName) {
  return new DOMTokenList(elem, propName);
}
